import { createSlice, PayloadAction } from "@reduxjs/toolkit";

export interface AwayEarnings {
  amount: number;
  seconds: number;
}

interface NotificationState {
  isOpen: boolean;
  unreadCount: number;
  awayInfo: AwayEarnings | null;
  awayBadge: boolean;
}

const initialState: NotificationState = {
  isOpen: false,
  unreadCount: 0,
  awayInfo: null,
  awayBadge: false,
};

const notificationSlice = createSlice({
  name: "notification",
  initialState,
  reducers: {
    setNotificationState: (state, action: PayloadAction<boolean>) => {
      state.isOpen = action.payload;
    },

    setUnreadCount: (state, action: PayloadAction<number>) => {
      state.unreadCount = action.payload;
    },

    incrementUnread: (state) => {
      state.unreadCount += 1;
    },
    resetUnread: (state) => {
      state.unreadCount = 0;
    },
    setAwayInfo: (state, action: PayloadAction<AwayEarnings | null>) => {
      state.awayInfo = action.payload;
    },
    setAwayBadge: (state, action: PayloadAction<boolean>) => {
      state.awayBadge = action.payload;
    },
  },
});

export const {
  setNotificationState,
  setUnreadCount,
  incrementUnread,
  resetUnread,
  setAwayInfo,
  setAwayBadge,
} = notificationSlice.actions;

export default notificationSlice.reducer;
